export default {
    name: 'account-register',
    components: {},
    props: [],
    data() {
        return {};
    },
    computed: {

    },
    mounted() {
        this._register();
    },
    methods: {
        _register() {
            let customClient = this.$route.params.customclient,
                promoCode = this.$route.params.promocode;

            if (!promoCode) {
                if (customClient) {
                    promoCode = customClient.split('/')[1];
                    customClient = customClient.split('/')[0];
                }
            }

            this.$authManager.signup(customClient, promoCode);
        }
    }
}
